import component from '../../../../props/component'
import form from '../../../../props/form'
import processing from '../../../../props/processing'

const defaultMenu = {
  edit: {
    title:'My Profile',
    component:'re-profile-edit',
    order: 0
  },
  settings: {
    title:  'Settings',
    component:  're-profile-settings',
    order: Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1
  }
}

const localProps = {
  tab: {},
  menu: {
    type: Array,
    default: function() {
      const mergedItems = _.merge(defaultMenu, this.$options.$$s('menu', {}))
      const filteredItems = _.omitBy(mergedItems, i => !i || i.enabled === false || i.disabled)
      const count = _.size(filteredItems)
      const unsortedItems = _.values(_.mapValues(filteredItems, (item, key) => {
          if (!_.isObject(item)) {
            item = {}
          }
          item['key'] = item.key || key
          item['title'] = item.title || _.startCase(key)
          item['component'] = item.component  || _.kebabCase(`re-profile-${key}`)
          item['order'] = _.isNil(item.order)  ? count : item.order
          return item
        }
      ))
      return unsortedItems.sort((a, b) => a.order - b.order)
    }
  },
  showLogoutTab: {
    type: [Boolean, Number],
    default() {
      return !!this.$options.$$s('showLogout', true)
    }
  },
  logoutTabLabel: {
    type: String,
    default() {
      return this.$options.$$t('logout.label', 'Log out')
    }
  },
  modalClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('popupClass', 're-modal-md')
    }
  },
  logoutModalTitle: {
    type: String,
    default() {
      return this.$options.$$t('logout.confirmation.title', 'Do you want to sign out of your profile?')
    }
  },
  logoutModalConfirmButtonTitle: {
    type: String,
    default() {
      return this.$options.$$t('logout.confirmation.yesButton.title', 'Yes')
    }
  },
  logoutModalCancelButtonTitle: {
    type: String,
    default() {
      return this.$options.$$t('logout.confirmation.noButton.title', 'No')
    }
  },

  title: {
    type: String,
    default() {
      return this.$options.$$t('title', 'My Account')
    }
  },
  showTitle: {
    type: [Boolean, Number],
    default() {
      return !!this.$options.$$s('showTitle', false)
    }
  },

  subTitle: {
    type: String,
    default() {
      return this.$options.$$t('subTitle', null)
    }
  },

  showSubTitle: {
    type: [Boolean, Number],
    default() {
      return !!this.$options.$$s('showSubTitle', false)
    }
  },

  notice: {
    type: String,
    default() {
      return this.$options.$$t('notice', '')
    }
  },
  showNotice: {
    type: [Boolean, Number],
    default() {
      return !!this.$options.$$s('showNotice', false)
    }
  },

  classes: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('classes', null)
    }
  },

  showLoginBox: {
    type: [Boolean, Number],
    default() {
      return !!this.$options.$$s('showLoginBox', true)
    }
  },

  signInButtonMessage: {
    type: String,
    default() {
      return this.$options.$$t('login.label', 'You are not logged in. {br} {button}')
    }
  },

  signInButtonTitle: {
    type: String,
    default() {
      return this.$options.$$t('login.button.title', this.$options.$$t('login.link.label', 'Sign in'))
    }
  },

  signInButtonClass: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('login.button.class', 'goto-login-button')
    }
  },

}
export const props = {
  ...component,
  ...form,
  ...processing,
  ...localProps
}
export default props
